export enum BriefingTypeEnum {
    BRIEFING = 'BRIEFING',
    ALERT = 'ALERT',
    BRIEFING_TEMPLATE = 'BRIEFING_TEMPLATE'
}
